<div class="totalizers-container">
  <div class="totalizer-area-monitorada">
    <div class="area-total-monitorada">
      <label for="">Número de Áreas Monitoradas</label>
      <p>{{ formatInteger(summary?.areasMonitored) }}</p>
    </div>

    <div class="area-total-monitorada">
      <label for="">Área Monitorada (ha)</label>
      <p>{{ formatDecimal(summary?.monitoredAreaHa) }}</p>
    </div>
  </div>

  <div class="area-plantada">
    <label for="">Área plantada de {{ cultura || "—" }} (ha)</label>
    <p>{{ formatDecimal(summary?.plantedCultureAreaHa) }}</p>
  </div>

  <div class="tiny-totalizers">
    <div class="em-desenvolvimento">
      <label for="">Em desenvolvimento (ha)</label>
      <p>{{ formatDecimal(summary?.developingAreaHa) }}</p>
    </div>
    <div class="em-senescencia">
      <label for="">Em senescência (ha)</label>
      <p>{{ formatDecimal(summary?.senescenceAreaHa) }}</p>
    </div>
    <div class="apto-colheita">
      <label for="">Apto para colheita (ha)</label>
      <p>{{ formatDecimal(summary?.readyForHarvestAreaHa) }}</p>
    </div>
    <div class="area-colhida">
      <label for="">Área colhida (ha)</label>
      <p>{{ formatDecimal(summary?.harvestedAreaHa) }}</p>
    </div>
  </div>

  <div class="extra-totalizers">
    <div class="aguardando-plantio">
      <label for="">Aguardando plantio (ha)</label>
      <p>{{ formatDecimal(summary?.awaitingPlantingAreaHa) }}</p>
    </div>
    <div class="identificacao">
      <label for="">Aguardando Identificação (ha)</label>
      <p>{{ formatDecimal(summary?.awaitingIdentificationAreaHa) }}</p>
    </div>
    <div>
      <label for="">Possível {{ cultura || "cultura" }} (ha)</label>
      <p>{{ formatDecimal(summary?.possiblyTargetCultureAreaHa) }}</p>
    </div>
    <div class="cultura-divergente">
      <label for="">Cultura divergente (ha)</label>
      <p>{{ formatDecimal(summary?.divergentCultureAreaHa) }}</p>
    </div>
    <div class="nao-plantado">
      <label for="">Não plantado (ha)</label>
      <p>{{ formatDecimal(summary?.notPlantedAreaHa) }}</p>
    </div>
  </div>
</div>
